export default "__VITE_ASSET__CDM0sicV__"